// ** React Imports
import { useState } from "react";
import { Grid, Button } from "semantic-ui-react";
import Email from "../../components/customInputs/email";
import Input from "../../components/customInputs/CustomText";
import Dob from "../../components/customInputs/DatePicker";
import SportDropDown from "../../components/customInputs/sportDropDown";
import PositionDropDown from "../../components/customInputs/Position";
import AdvocateDD from "../../components/customInputs/AdvocateDD";
import { useDispatch } from "react-redux";
import { newSignupRequest } from "../../store/actions/newSignup";
import CSV from "../../components/layout/DownloadCSV";

const Step1 = (props) => {
  // let data;
  const [data, setdata] = useState({});
  const [showDob, setDOB] = useState();
  const [gmail, setGmail] = useState(null);
  const [PEmail1, setPEmail1] = useState(null);
  const [PNum1, setPNum1] = useState(null);
  const [PNum2, setPNum2] = useState(null);
  const [PEmail2, setPEmail2] = useState(null);
  const [error, setError] = useState(null);
  const [travel, setTravel] = useState(null);
  const [classYear, setClassYear] = useState(null);
  const [sport, setSport] = useState(null);
  const [PPosition, setPPosition] = useState(null);
  const [SPosition, setSPosition] = useState(null);
  const [resides, setResides] = useState(null);
  const [father, setFather] = useState(null);
  const [mother, setMother] = useState(null);
  const [advocate, setAdvocate] = useState(null);
  const [athleteNumber, setAthleteNumber] = useState(null);
  const [School, setSchool] = useState(null);
  const [Comment, setComment] = useState(null);
  const [ref, setRef] = useState(null);
  const dispatch = useDispatch();
  const handleSubmit = () => {
    if (
      props.classYear &&
      !showDob &&
      !gmail &&
      !PEmail1 &&
      !PNum1 &&
      !PNum2 &&
      !PEmail2 &&
      !travel &&
      !classYear &&
      !sport &&
      !PPosition &&
      !SPosition &&
      !resides &&
      !father &&
      !mother &&
      !advocate &&
      !athleteNumber &&
      !School
    ) {
      props.stepper.next();
      window.scroll(0, 0);
    } else if (
      showDob &&
      gmail &&
      PEmail1 &&
      PNum1 &&
      PNum2 &&
      PEmail2 &&
      travel &&
      classYear &&
      sport &&
      PPosition &&
      SPosition &&
      resides &&
      father &&
      mother &&
      advocate &&
      athleteNumber &&
      School
    ) {
      const data = {
        id: props.userUid,
        dob: showDob,
        gmail,
        parentsEmail1: PEmail1,
        parentsEmail2: PEmail2,
        parentsPhone1: Number(PNum1),
        parentsPhone2: Number(PNum2),
        travelTeam: travel,
        classYear,
        sport,
        primaryPosition: PPosition,
        secondaryPosition: SPosition,
        resides,
        fatherName: father,
        motherName: mother,
        advocate,
        athletesPhone: Number(athleteNumber),
        school: School,
        comment: Comment ? Comment : null,
        ref: ref ? ref : null,
        status: null,
      };
      setdata(data);
      dispatch(newSignupRequest(data));
      props.stepper.next();
      window.scroll(0, 0);
    } else {
      setError("Fields with * are required");
    }
  };

  return (
    <>
      <div className="step-header">
        <h2 className="step-header-head">Personal information</h2>
        {/* <p className="step-header-text">Please provide relevent information.</p> */}
        {error && <p className="errorText">{error}</p>}
        {props.classYear && !error && (
          <p className="errorText">Your 1st Step Is Cleared</p>
        )}
      </div>
      {!props.classYear && (
        <Grid divided="vertically">
          <Grid.Row stackable="true">
            <Input
              getError={(e) => setError(e)}
              getValue={(e) => setTravel(e)}
              name="Travel Team"
            />
            <Dob dob={showDob} getDob={setDOB} />
            <Input
              getError={(e) => setError(e)}
              getValue={(e) => setClassYear(e)}
              name="High School Graduation Year"
              year
            />
            <SportDropDown
              getError={(e) => setError(e)}
              getValue={(e) => setSport(e)}
            />
            <PositionDropDown
              sport={sport}
              getError={(e) => setError(e)}
              getValue={(e) => setPPosition(e)}
            />
            <PositionDropDown
              secondary
              sport={sport}
              getError={(e) => setError(e)}
              getValue={(e) => setSPosition(e)}
            />
            <Input
              wide
              getError={(e) => setError(e)}
              getValue={(e) => setResides(e)}
              name="State Student Athlete resides"
            />
            <Email
              wide
              gmail
              getError={(e) => setError(e)}
              getEmail={(e) => setGmail(e)}
              name="Athelete's Gmail"
            />
            <Email
              getError={(e) => setError(e)}
              getEmail={(e) => setPEmail1(e)}
              name="Parent Email #1 "
            />
            <Email
              getError={(e) => setError(e)}
              getEmail={(e) => setPEmail2(e)}
              name="Parent Email #2 "
            />
            <Input
              getError={(e) => setError(e)}
              getValue={(e) => setMother(e)}
              name="Mother's Name"
            />
            <Input
              getError={(e) => setError(e)}
              getValue={(e) => setFather(e)}
              name="Father's Name"
            />
            <AdvocateDD
              getError={(e) => setError(e)}
              getValue={(e) => setAdvocate(e)}
            />
            <Input
              getError={(e) => setError(e)}
              getValue={(e) => setPNum1(e)}
              name="Parent #1 Phone Number"
              phoneNumber
            />
            <Input
              getError={(e) => setError(e)}
              getValue={(e) => setPNum2(e)}
              name="Parent #2 Phone Number"
              phoneNumber
            />
            <Input
              getError={(e) => setError(e)}
              getValue={(e) => setAthleteNumber(e)}
              name="Athlete's Phone Number"
              phoneNumber
            />
            <Input
              wide
              getError={(e) => setError(e)}
              getValue={(e) => setSchool(e)}
              name="High School Name, City / State"
            />
            <Input
              wide
              getError={(e) => setError(e)}
              getValue={(e) => setComment(e)}
              name="Other thoughts or comments"
              notReq
            />
            <Input
              wide
              getError={(e) => setError(e)}
              getValue={(e) => setRef(e)}
              name="Referrence name if any"
              notReq
            />
          </Grid.Row>
        </Grid>
      )}
      <div className="footer-btn-data single">
        {!props.classYear ? (
          <CSV data={data}>
            <Button
              primary
              disabled={error}
              onClick={() => {
                handleSubmit();
              }}
            >
              Next
            </Button>
          </CSV>
        ) : (
          <Button
            primary
            disabled={error}
            onClick={() => {
              handleSubmit();
            }}
          >
            Next
          </Button>
        )}
      </div>
    </>
  );
};

export default Step1;
